module.exports = __webpack_public_path__ + "static/media/globo.b616b2c0.png";